export default __webpack_public_path__ + "static/media/drum loop_1.6ed19fca.wav";